export const clusters = [
  {
    id: "moradabad",
    name: "Moradabad",
    state: "Uttar Pradesh",
    nickname: "Brass City",
    material: "Brass · metalware",
    spec: "MOQ 500 · 35-day lead · BSCI / Sedex audited",
    coords: { x: 158, y: 120 },
    labelOffset: { x: 0, y: -12 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/hz98lfmc_B85AC5D2-0E01-448A-BFEE-C4E8E687E4D3.png",
    geo: { lat: 28.8386, lng: 78.7733 },
    headline: "Brass, metalware and lighting — sourced where the craft actually lives.",
    intro:
      "Moradabad has been India's Brass City for more than four hundred years. Our headquarters has been here since 2002 — the foundry floors are a fifteen-minute drive, and our QC inspectors walk them every week. Pendants, lamps, ware, finishings and architectural metal.",
    detail: {
      moq: "500 units",
      lead: "35 days",
      certs: "BSCI · Sedex",
      capability: "Brass casting, spinning, electroplating, lacquering",
    },
    capabilities: [
      "Sand casting · centrifugal casting · gravity die",
      "Hand spinning and CNC spinning for ware and pendants",
      "Electroplating: brass, copper, nickel, gunmetal, antique finishes",
      "Hand patination and lacquer · matte / satin / gloss",
      "Photometric and salt-spray testing on site",
    ],
    products: ["Lighting", "Brass & metalware", "Home décor"],
    facts: [
      ["MOQ", "500 units"],
      ["Lead time", "35 days"],
      ["Active factories", "70+"],
      ["Certifications", "BSCI · Sedex · ISO 9001"],
      ["QC standard", "AQL 2.5 · photometric · salt-spray"],
      ["Heritage", "400+ years"],
    ],
  },
  {
    id: "firozabad",
    name: "Firozabad",
    state: "Uttar Pradesh",
    nickname: "The Glass City",
    material: "Glass · lighting",
    spec: "MOQ 1,000 · hand-blown & pressed · in-line QC",
    coords: { x: 146, y: 138 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/zrja1grd_58C9B5C2-8860-492D-9420-5CE424B83120.png",
    geo: { lat: 27.1591, lng: 78.3957 },
    headline: "India's glass capital — hand-blown, pressed and lampworked.",
    intro:
      "Firozabad makes a remarkable percentage of the world's hand-blown glass bangles, and the same furnaces are equally fluent in lighting shades, vases and decorative ware. Our team works with a shortlist of fifteen workshops here, all annealed properly and inspected to ISTA-3A packing.",
    detail: {
      moq: "1,000 units",
      lead: "40 days",
      certs: "ISO 9001",
      capability: "Hand-blown, pressed glass, decorative shades",
    },
    capabilities: [
      "Hand-blown soda-lime and lead crystal",
      "Pressed and moulded shades and ware",
      "Cut, frosted and lustred finishes",
      "Lampworked accent and pendant pieces",
      "ISTA-3A drop-test certified packing on every SKU",
    ],
    products: ["Lighting", "Home décor"],
    facts: [
      ["MOQ", "1,000 units"],
      ["Lead time", "40 days"],
      ["Active factories", "15+"],
      ["Certifications", "ISO 9001"],
      ["QC standard", "AQL 2.5 · annealing test · ISTA-3A"],
      ["Heritage", "200+ years"],
    ],
  },
  {
    id: "jaipur",
    name: "Jaipur",
    state: "Rajasthan",
    nickname: "The Pink City",
    material: "Blue pottery · décor",
    spec: "MOQ 300 · hand-painted · breakage-tested packing",
    coords: { x: 118, y: 150 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/4vshlb6w_2488C0C8-9F5F-49CB-B89B-957A4819DF61.png",
    geo: { lat: 26.9124, lng: 75.7873 },
    headline: "Blue pottery, ceramic and hand-painted décor — heritage craft, modern packing.",
    intro:
      "Jaipur's blue pottery is a GI-tagged craft tradition that traces back to Mughal-era Persian artisans. We work with four workshops here on hand-painted blue pottery, ceramic ware and mixed-media décor — and we rebuilt their packing from the inside out so margin survives transit.",
    detail: {
      moq: "300 units",
      lead: "45 days",
      certs: "Fair-trade",
      capability: "Hand-painted blue pottery, ceramic, terracotta",
    },
    capabilities: [
      "Hand-painted blue pottery (GI-tagged craft)",
      "Stoneware and terracotta",
      "Stencil and freehand decoration",
      "Re-engineered ISTA-3A packing to drop tested standard",
      "Lead and cadmium lab testing on every glaze batch",
    ],
    products: ["Home décor", "Lighting"],
    facts: [
      ["MOQ", "300 units"],
      ["Lead time", "45 days"],
      ["Active factories", "4+"],
      ["Certifications", "Fair-trade · GI tag"],
      ["QC standard", "AQL 2.5 · ISTA-3A · lead/cadmium lab"],
      ["Heritage", "Mughal-era"],
    ],
  },
  {
    id: "jodhpur",
    name: "Jodhpur",
    state: "Rajasthan",
    nickname: "The Blue City",
    material: "Carved & metal furniture",
    spec: "MOQ 50 · solid sheesham · moisture-controlled",
    coords: { x: 98, y: 168 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/b844eelb_9C323BD6-C46B-4B29-8703-06684A96BCD0.png",
    geo: { lat: 26.2389, lng: 73.0243 },
    headline: "Solid-wood furniture, FSC sheesham, moisture-controlled warehousing.",
    intro:
      "Jodhpur is the global hub for solid-wood and industrial-iron furniture. Our partner workshops here run kiln-dried, moisture-checked sheesham and mango wood with iron and brass detailing. Single-shop dining, bedroom, living and seating ranges — sampled in six weeks.",
    detail: {
      moq: "50 units",
      lead: "60 days",
      certs: "FSC available",
      capability: "Sheesham, mango wood, iron, industrial furniture",
    },
    capabilities: [
      "FSC-certified sheesham and mango wood",
      "Kiln-dried · 10-12% moisture content verified",
      "Solid joinery: mortise · tenon · dovetail",
      "Iron forging and industrial finishing",
      "Single-factory dining, bedroom and living ranges",
    ],
    products: ["Furniture"],
    facts: [
      ["MOQ", "50 units"],
      ["Lead time", "60 days"],
      ["Active factories", "30+"],
      ["Certifications", "FSC · BSCI"],
      ["QC standard", "Moisture meter · finish · structural"],
      ["Heritage", "Princely-era craft"],
    ],
  },
  {
    id: "saharanpur",
    name: "Saharanpur",
    state: "Uttar Pradesh",
    nickname: "Wood Carving Capital",
    material: "Wood carving",
    spec: "MOQ 100 · hand-carved · FSC options",
    coords: { x: 150, y: 104 },
    labelOffset: { x: 0, y: -10 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/b844eelb_9C323BD6-C46B-4B29-8703-06684A96BCD0.png",
    geo: { lat: 29.964, lng: 77.5462 },
    headline: "Carved wood, inlay and intricate panels — by hand, generation to generation.",
    intro:
      "Saharanpur's wood-carving tradition is recognised by India's GI Registry. We work with workshops here on carved screens, panels, decorative boxes and inlay — including FSC-certified material chains for clients who need it.",
    detail: {
      moq: "100 units",
      lead: "55 days",
      certs: "FSC available",
      capability: "Hand-carved wood, inlay, intricate panels",
    },
    capabilities: [
      "Hand-carved relief and screen work",
      "Brass / bone / mother-of-pearl inlay",
      "Sheesham · mango · acacia · teak",
      "FSC chain-of-custody option",
      "Lacquer and natural-oil finishing",
    ],
    products: ["Home décor", "Furniture"],
    facts: [
      ["MOQ", "100 units"],
      ["Lead time", "55 days"],
      ["Active factories", "20+"],
      ["Certifications", "FSC · GI tag"],
      ["QC standard", "Carving fidelity · finish · moisture"],
      ["Heritage", "400+ years"],
    ],
  },
  {
    id: "panipat",
    name: "Panipat",
    state: "Haryana",
    nickname: "Textile City",
    material: "Textile · soft furnishing",
    spec: "MOQ 500 · recycled-yarn options · GOTS available",
    coords: { x: 138, y: 92 },
    labelOffset: { x: 0, y: -10 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/xu2xk2cz_988D7A5B-F1F2-4D28-B07C-5BED7079D975.png",
    geo: { lat: 29.3909, lng: 76.9635 },
    headline: "Recycled-yarn throws, rugs and soft furnishing — GOTS and GRS available.",
    intro:
      "Panipat is the recycled-textile capital of India. We work with mills here on rugs, throws, cushions and soft furnishing — recycled yarn (GRS), organic cotton (GOTS), block-print and woven. Twelve-week lead times for full programs.",
    detail: {
      moq: "500 units",
      lead: "40 days",
      certs: "GOTS · GRS",
      capability: "Rugs, throws, cushions, recycled yarn",
    },
    capabilities: [
      "GRS-certified recycled-yarn programs",
      "GOTS-certified organic cotton",
      "Handloom · powerloom · tufted",
      "Block-print and screen-print on natural fibre",
      "Colour-fastness, pilling and fibre-content lab testing",
    ],
    products: ["Textile"],
    facts: [
      ["MOQ", "500 units"],
      ["Lead time", "40 days"],
      ["Active factories", "25+"],
      ["Certifications", "GOTS · GRS"],
      ["QC standard", "Colour-fastness · pilling · fibre-content"],
      ["Heritage", "1947 onward"],
    ],
  },
  {
    id: "noida",
    name: "Noida",
    state: "Uttar Pradesh",
    nickname: "Mixed-décor hub",
    material: "Mixed home décor",
    spec: "MOQ 300 · multi-material · consolidation hub",
    coords: { x: 152, y: 112 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/gqduxjol_726E87B1-EBA3-468C-A80D-10361D4B5515.png",
    geo: { lat: 28.5355, lng: 77.391 },
    headline: "Multi-material décor and lifestyle — gifting, seasonal and private label.",
    intro:
      "Noida sits in the Delhi NCR consolidation belt — multi-material lifestyle and décor workshops who can run mixed-material SKUs (metal + wood + glass + textile in one order). Useful for gifting programs and seasonal lines.",
    detail: {
      moq: "300 units",
      lead: "30 days",
      certs: "BSCI · Sedex",
      capability: "Multi-material décor, lifestyle, gifting",
    },
    capabilities: [
      "Multi-material SKU development",
      "Gifting and seasonal programs",
      "Private-label boxing and FOL",
      "Quick-turn programs (30-day lead)",
      "Consolidation with the rest of our shipments",
    ],
    products: ["Home décor", "Lighting", "Brass & metalware"],
    facts: [
      ["MOQ", "300 units"],
      ["Lead time", "30 days"],
      ["Active factories", "40+"],
      ["Certifications", "BSCI · Sedex"],
      ["QC standard", "AQL 2.5 · multi-material"],
      ["Heritage", "Modern (post-1990)"],
    ],
  },
  {
    id: "delhi",
    name: "Delhi",
    state: "Delhi NCT",
    nickname: "Export base",
    material: "Sourcing & export base",
    spec: "QC lab · consolidation · export documentation",
    coords: { x: 130, y: 106 },
    labelOffset: { x: -16, y: 0 },
    labelAnchor: "end",
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/zzgyqzwg_FF7EE322-FEAC-41FD-B430-6BB7D8D566BC.png",
    geo: { lat: 28.6139, lng: 77.209 },
    headline: "QC lab, consolidation hub, export documentation — one bill of lading.",
    intro:
      "Delhi NCR is our consolidation hub. Containers are loaded under our supervision, photographed and sealed; CHA-handled export documentation; six active export ports. The fastest 'one bill of lading, one ship date' chain in our network.",
    detail: {
      moq: "—",
      lead: "—",
      certs: "ISO 9001",
      capability: "QC lab, consolidation, export documentation",
    },
    capabilities: [
      "Containerised consolidation",
      "CHA-handled export documentation",
      "Six active export ports — Nhava Sheva, Mundra, Chennai, Kolkata + bound services",
      "QC lab on site (photometric, material, salt-spray)",
      "Loading photography on every container",
    ],
    products: ["All categories"],
    facts: [
      ["Service", "Consolidation"],
      ["Lead time", "—"],
      ["Active ports", "6"],
      ["Certifications", "ISO 9001"],
      ["QC standard", "On-site lab"],
      ["Heritage", "Our HQ from 2010"],
    ],
  },
  {
    id: "bhadohi",
    name: "Bhadohi",
    state: "Uttar Pradesh",
    nickname: "Carpet City of India",
    material: "Hand-knotted carpets · dhurries",
    spec: "MOQ 200 sqm · hand-knotted · GoodWeave certified",
    coords: { x: 172, y: 138 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/xu2xk2cz_988D7A5B-F1F2-4D28-B07C-5BED7079D975.png",
    geo: { lat: 25.3986, lng: 82.5697 },
    headline: "The Carpet City of India — hand-knotted rugs, dhurries and heritage weaves.",
    intro:
      "Bhadohi in eastern Uttar Pradesh is the world's largest hand-knotted carpet weaving cluster and a Geographical Indication (GI) protected craft belt. Our partner looms here weave wool, silk-mix and jute carpets in Persian, tribal and contemporary designs — every piece independently GoodWeave audited for child-labour-free supply chain. Programmes ship as 20-ft or 40-ft containers with roll-and-poly-wrap packing and full COO documentation.",
    detail: {
      moq: "200 sqm",
      lead: "75 days",
      certs: "GoodWeave · GI tag · ISO 9001",
      capability: "Hand-knotted wool, silk-mix, tufted and dhurrie carpets",
    },
    capabilities: [
      "Hand-knotted 100% wool, wool-silk blends, bamboo silk",
      "Hand-tufted and hand-woven flatweave dhurries",
      "Custom colour and Pantone dye-lot matching",
      "GoodWeave chain-of-custody on every roll",
      "Colour-fastness, tuft-bind and pile-density lab testing",
    ],
    products: ["Textile", "Home décor"],
    facts: [
      ["MOQ", "200 sqm"],
      ["Lead time", "75 days"],
      ["Active looms", "40+"],
      ["Certifications", "GoodWeave · GI · ISO 9001"],
      ["QC standard", "AQL 2.5 · tuft-bind · colour-fast"],
      ["Heritage", "500+ years"],
    ],
  },
  {
    id: "varanasi",
    name: "Varanasi",
    state: "Uttar Pradesh",
    nickname: "Silk City",
    material: "Silk weaving · brocade · handloom",
    spec: "MOQ 300 mtr · handloom · GI-tagged Banarasi",
    coords: { x: 174, y: 142 },
    labelOffset: { x: 0, y: -12 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/xu2xk2cz_988D7A5B-F1F2-4D28-B07C-5BED7079D975.png",
    geo: { lat: 25.3176, lng: 82.9739 },
    headline: "Banarasi silk, brocade and handloom carpets — GI-tagged heritage weaves.",
    intro:
      "Varanasi (Banaras) is the beating heart of India's handloom silk industry — a GI-protected craft cluster that has woven zari brocade and kadhwa silks for more than five centuries. Our workshops here run pure silk, silk-cotton blends, chiffon-brocade and heritage Banarasi programmes; the same city is also a major hand-knotted carpet centre alongside neighbouring Bhadohi. Every roll ships with weaver-attribution documentation for buyers whose brand story rewards traceability.",
    detail: {
      moq: "300 mtr",
      lead: "70 days",
      certs: "GI-tag · Handloom Mark · GoodWeave",
      capability: "Banarasi silk, brocade, handloom, hand-knotted rugs",
    },
    capabilities: [
      "Handloom pure silk, katan silk and organza",
      "Real-zari and tested-zari brocade weaving",
      "Hand-knotted wool and silk carpets (Bhadohi-Varanasi belt)",
      "Custom Pantone dyeing and traditional vegetable dyes",
      "Handloom Mark and GI tag documentation",
    ],
    products: ["Textile", "Home décor", "Fashion accessories"],
    facts: [
      ["MOQ", "300 mtr"],
      ["Lead time", "70 days"],
      ["Active weavers", "60+"],
      ["Certifications", "GI · Handloom Mark · GoodWeave"],
      ["QC standard", "Yarn count · zari purity · colour-fast"],
      ["Heritage", "500+ years"],
    ],
  },
  {
    id: "agra",
    name: "Agra",
    state: "Uttar Pradesh",
    nickname: "The Marble City",
    material: "Marble inlay · leather · handicrafts",
    spec: "MOQ 100 · marble pietra dura · leather goods",
    coords: { x: 132, y: 138 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/gqduxjol_726E87B1-EBA3-468C-A80D-10361D4B5515.png",
    geo: { lat: 27.1767, lng: 78.0081 },
    headline: "Marble inlay heritage from the shadow of the Taj Mahal — plus finished leather.",
    intro:
      "Agra is home to two entirely different craft ecosystems that share one city. The first is Makrana-marble pietra dura inlay — the exact craft that built the Taj Mahal in the 17th century, still practised by descendant artisan families on trays, table-tops, coasters, boxes and architectural panels. The second is a modern export leather belt: finished shoes, bags and accessories from BSCI-audited factories. Our team runs QC in both quarters and consolidates through Delhi.",
    detail: {
      moq: "100 units",
      lead: "55 days",
      certs: "BSCI · Sedex · GI tag (Agra marble)",
      capability: "Marble inlay, pietra dura, leather goods, handicrafts",
    },
    capabilities: [
      "Hand-cut Makrana marble inlay (pietra dura)",
      "Semi-precious stone setting: lapis, malachite, mother-of-pearl",
      "Full-grain leather goods · finished shoes and bags",
      "Marble carving, jali screens, architectural panels",
      "Vibration-safe cushioned packing on inlay pieces",
    ],
    products: ["Home décor", "Fashion accessories"],
    facts: [
      ["MOQ", "100 units"],
      ["Lead time", "55 days"],
      ["Active workshops", "35+"],
      ["Certifications", "BSCI · Sedex · GI"],
      ["QC standard", "Inlay fidelity · leather · pack safety"],
      ["Heritage", "17th century (Mughal)"],
    ],
  },
  {
    id: "gurugram",
    name: "Gurugram",
    state: "Haryana",
    nickname: "Contract-Manufacturing Belt",
    material: "Contract manufacturing · exports",
    spec: "MOQ 300 · multi-material · export-hub factories",
    coords: { x: 138, y: 116 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/gqduxjol_726E87B1-EBA3-468C-A80D-10361D4B5515.png",
    geo: { lat: 28.4595, lng: 77.0266 },
    headline: "Contract-manufacturing and export-hub factories in the Delhi NCR belt.",
    intro:
      "Gurugram (Gurgaon) sits inside the Delhi NCR export belt and hosts one of India's densest concentrations of contract-manufacturing factories — mixed-material home décor, lifestyle, gifting, private-label programmes and export-quality metal, wood and textile combined SKUs. Our Gurugram network runs BSCI-audited factories with English-fluent operations, quick-turn 30-day lead times and direct consolidation into our Delhi hub for single-container programmes.",
    detail: {
      moq: "300 units",
      lead: "30 days",
      certs: "BSCI · Sedex · ISO 9001",
      capability: "Contract manufacturing, mixed-material, private label",
    },
    capabilities: [
      "Multi-material private-label SKU development",
      "Quick-turn 30-day export programmes",
      "BSCI · Sedex · SA8000 audited factories",
      "Direct rail and road link to Nhava Sheva and Mundra",
      "Consolidation into our Delhi NCR hub for single BOL programmes",
    ],
    products: ["Home décor", "Brass & metalware", "Textile"],
    facts: [
      ["MOQ", "300 units"],
      ["Lead time", "30 days"],
      ["Active factories", "50+"],
      ["Certifications", "BSCI · Sedex · ISO 9001"],
      ["QC standard", "AQL 2.5 · multi-material"],
      ["Heritage", "Modern export hub (post-2000)"],
    ],
  },
  {
    id: "channapatna",
    name: "Channapatna",
    state: "Karnataka",
    nickname: "Toy Town of India",
    material: "Lacquered wood · toys · craft",
    spec: "MOQ 500 · GI-tagged lacquerware · lead-free non-toxic",
    coords: { x: 108, y: 240 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/gqduxjol_726E87B1-EBA3-468C-A80D-10361D4B5515.png",
    geo: { lat: 12.6514, lng: 77.2075 },
    headline: "GI-tagged Channapatna lacquer wooden toys, craft and décor — safe non-toxic finishes.",
    intro:
      "Channapatna in Karnataka is India's Toy Town — a Geographical Indication (GI) protected wooden-toy and lacquerware cluster with a 200-year continuous artisan tradition. Our partner workshops here produce heritage lacquered wooden toys, décor turned-ware, kitchen accessories and craft pieces using lead-free vegetable dyes and food-safe non-toxic lacquer finishes. Every SKU is CPSIA and EN 71 lab-tested for children's product markets. Ivory-wood (aale mara) and rosewood used as the primary substrates.",
    detail: {
      moq: "500 units",
      lead: "45 days",
      certs: "GI tag · CPSIA · EN 71 · Fairtrade",
      capability: "Lacquered wooden toys, décor turnery, GI-tagged craft",
    },
    capabilities: [
      "Traditional lacquer turning on ivory-wood (aale mara) and rosewood",
      "Lead-free vegetable dye and food-safe non-toxic lacquer finishes",
      "CPSIA and EN 71 lab-tested for children's product markets",
      "GI-tagged Channapatna craft chain-of-custody documentation",
      "Fairtrade cooperative artisan cluster",
    ],
    products: ["Home décor", "Fashion accessories"],
    facts: [
      ["MOQ", "500 units"],
      ["Lead time", "45 days"],
      ["Active workshops", "35+"],
      ["Certifications", "GI · CPSIA · EN 71 · Fairtrade"],
      ["QC standard", "Lead-free · non-toxic · children's-safe"],
      ["Heritage", "200+ years"],
    ],
  },
  {
    id: "karur",
    name: "Karur",
    state: "Tamil Nadu",
    nickname: "Home Textile City of India",
    material: "Home textile · woven furnishing",
    spec: "MOQ 500 · GOTS · GRS · handloom & powerloom",
    coords: { x: 118, y: 254 },
    labelOffset: { x: 0, y: -12 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/xu2xk2cz_988D7A5B-F1F2-4D28-B07C-5BED7079D975.png",
    geo: { lat: 10.9601, lng: 78.0766 },
    headline: "Home textile capital of South India — kitchen linen, bed linen, table linen, mats.",
    intro:
      "Karur in Tamil Nadu is South India's home-textile export capital and one of the world's largest kitchen-linen manufacturing clusters. Our partner mills here run woven cotton kitchen textiles, table linen, bed linen, bath linen and floor mats — GOTS-certified organic cotton and GRS-certified recycled yarn supply chains supported. Karur ships primarily through Chennai and Tuticorin ports, giving South-EU and US East Coast programmes a freight advantage over North Indian textile origins.",
    detail: {
      moq: "500 units",
      lead: "45 days",
      certs: "GOTS · GRS · OEKO-TEX · BSCI · Sedex",
      capability: "Kitchen linen, bed linen, table linen, bath linen, floor mats",
    },
    capabilities: [
      "GOTS-certified organic cotton kitchen and bed linen",
      "GRS-certified recycled-yarn programmes",
      "OEKO-TEX Standard 100 lab-tested textiles",
      "Handloom and powerloom capacity across 60+ mills",
      "Chennai and Tuticorin port advantage for South-EU / US East Coast",
    ],
    products: ["Textile"],
    facts: [
      ["MOQ", "500 units"],
      ["Lead time", "45 days"],
      ["Active mills", "60+"],
      ["Certifications", "GOTS · GRS · OEKO-TEX · BSCI"],
      ["QC standard", "Colour-fastness · shrinkage · absorbency · GSM"],
      ["Heritage", "1980s onward · export-led"],
    ],
  },
  {
    id: "kashmir",
    name: "Kashmir",
    state: "Jammu & Kashmir",
    nickname: "Heritage Craft Valley",
    material: "Pashmina · paper mache · walnut carving",
    spec: "MOQ 200 · pashmina · GI-tagged crafts",
    coords: { x: 128, y: 76 },
    labelOffset: { x: 0, y: 14 },
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/hz98lfmc_B85AC5D2-0E01-448A-BFEE-C4E8E687E4D3.png",
    geo: { lat: 34.0837, lng: 74.7973 },
    headline: "Pashmina shawls, paper mache and walnut carving — Kashmir's four GI-protected crafts.",
    intro:
      "Kashmir Valley is home to four distinct Geographical Indication (GI) protected craft ecosystems: Kani and Sozni pashmina shawls, hand-painted paper mache, walnut wood carving and hand-knotted silk carpets. Our sourcing programmes here work with cooperative artisan clusters in Srinagar, Ganderbal and Anantnag — every shawl carries a Pashmina GI mark, every carpet is GoodWeave audited, and every paper mache batch is lead-free lab tested. Cold-chain logistics through Jammu and Delhi.",
    detail: {
      moq: "200 units",
      lead: "80 days",
      certs: "GI tag (Pashmina) · GoodWeave · Craftmark",
      capability: "Pashmina shawls, paper mache, walnut carving, silk carpets",
    },
    capabilities: [
      "Pashmina, Cashmere and Kani-woven shawls (GI-tagged)",
      "Sozni and tilla hand embroidery",
      "Hand-painted lead-free paper mache",
      "Walnut wood carving — furniture and décor",
      "Hand-knotted silk and silk-wool carpets",
    ],
    products: ["Textile", "Home décor", "Fashion accessories"],
    facts: [
      ["MOQ", "200 units"],
      ["Lead time", "80 days"],
      ["Active cooperatives", "25+"],
      ["Certifications", "GI · GoodWeave · Craftmark"],
      ["QC standard", "Yarn micronage · GI trace · lead-free"],
      ["Heritage", "600+ years"],
    ],
  },
];

export const categories = ["Lighting", "Furniture", "Home décor", "Textile"];

export const clusterByCategory = {
  Lighting: ["moradabad", "firozabad"],
  Furniture: ["jodhpur", "saharanpur"],
  "Home décor": ["jaipur", "noida", "agra", "kashmir"],
  Textile: ["panipat", "bhadohi", "varanasi", "kashmir"],
};

export const getCluster = (id) => clusters.find((c) => c.id === id);


/**
 * Build a 4-question FAQ for a cluster from its existing fields.
 * Used both for visible HTML rendering and for FAQPage JSON-LD on /clusters/:id.
 */
export const buildClusterFaq = (c) => {
  if (!c) return [];
  const capability = c.detail?.capability || (c.capabilities || []).slice(0, 3).join(", ");
  const certs = c.detail?.certs || "BSCI · Sedex";
  const products = (c.products || []).join(", ");
  return [
    {
      q: `What does ${c.name} manufacture?`,
      a: `${c.name} is India's ${c.nickname.toLowerCase()} — primary capabilities cover ${capability}. Typical product categories sourced from here: ${products}.`,
    },
    {
      q: `What is the minimum order quantity (MOQ) and lead time from ${c.name}?`,
      a: `Asia Sourcing's standard programme from ${c.name} runs at ${c.detail?.moq || "500 units"} MOQ with a ${c.detail?.lead || "35-day"} lead time, container-loaded and AQL-inspected before despatch.`,
    },
    {
      q: `What certifications and audits cover ${c.name} factories?`,
      a: `Factories in our ${c.name} network are ${certs} audited. We run AQL 2.5 random inspections, photometric / structural / chemical lab tests as relevant to the SKU, and document every container with photo evidence.`,
    },
    {
      q: `How does Asia Sourcing operate in ${c.name}?`,
      a: `${c.intro}`,
    },
  ];
};
